var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1668 22.3334L42.8335 55.6667C42.1668 56.3334 41.5002 56.6667 40.5002 56.6667H27.1668C25.1668 56.6667 23.8335 55.3334 23.8335 53.3334V40C23.8335 39 24.1668 38.3334 24.8335 37.6667L58.1668 4.33337C59.5002 3.00004 61.5002 3.00004 62.8335 4.33337L76.1668 17.6667C77.5002 19 77.5002 21 76.1668 22.3334ZM70.5002 49V66.6667C70.5002 72.3334 66.1668 76.6667 60.5002 76.6667H13.8335C8.16683 76.6667 3.8335 72.3334 3.8335 66.6667V20C3.8335 14.3334 8.16683 10 13.8335 10H31.5002C33.5002 10 34.8335 11.3334 34.8335 13.3334C34.8335 15.3334 33.5002 16.6667 31.5002 16.6667H13.8335C11.8335 16.6667 10.5002 18 10.5002 20V66.6667C10.5002 68.6667 11.8335 70 13.8335 70H60.5002C62.5002 70 63.8335 68.6667 63.8335 66.6667V49C63.8335 47 65.1668 45.6667 67.1668 45.6667C69.1668 45.6667 70.5002 47 70.5002 49ZM60.5002 11.3334L69.1668 20L39.1668 50H30.5002V41.3334L60.5002 11.3334Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_679_5289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 75,
    height: 74
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1668 22.3334L42.8335 55.6667C42.1668 56.3334 41.5002 56.6667 40.5002 56.6667H27.1668C25.1668 56.6667 23.8335 55.3334 23.8335 53.3334V40C23.8335 39 24.1668 38.3334 24.8335 37.6667L58.1668 4.33337C59.5002 3.00004 61.5002 3.00004 62.8335 4.33337L76.1668 17.6667C77.5002 19 77.5002 21 76.1668 22.3334ZM70.5002 49V66.6667C70.5002 72.3334 66.1668 76.6667 60.5002 76.6667H13.8335C8.16683 76.6667 3.8335 72.3334 3.8335 66.6667V20C3.8335 14.3334 8.16683 10 13.8335 10H31.5002C33.5002 10 34.8335 11.3334 34.8335 13.3334C34.8335 15.3334 33.5002 16.6667 31.5002 16.6667H13.8335C11.8335 16.6667 10.5002 18 10.5002 20V66.6667C10.5002 68.6667 11.8335 70 13.8335 70H60.5002C62.5002 70 63.8335 68.6667 63.8335 66.6667V49C63.8335 47 65.1668 45.6667 67.1668 45.6667C69.1668 45.6667 70.5002 47 70.5002 49ZM60.5002 11.3334L69.1668 20L39.1668 50H30.5002V41.3334L60.5002 11.3334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_679_5289)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    fill: "#2FA5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit_green.77ad392594a5e3f1935929719559e575.svg";
export { ForwardRef as ReactComponent };